import {checkLabelValueObject} from './checkObjects';

/**
 * Filter a list to be unique with a callback who defines the comparaison
 * @param {Array} array
 * @param {Function} compCallback
 * @return {Array}
 */
const uniqBy = (array, compCallback) => {
    const seen = {};
    return array.filter((item) => {
        const k = compCallback(item);
        return seen.hasOwnProperty(k) ? false : (seen[k] = true);
    });
};

/**
 * Return true if there are common item in the two arrays
 * @param {[]} glNumberArr
 * @param {[]} allocatedForArr
 * @return {boolean}
 */
export const haveCommonElements = (glNumberArr, allocatedForArr) => {
    if (glNumberArr.length === 0 || allocatedForArr.length === 0) {
        return false;
    }
    return allocatedForArr.every((item) => glNumberArr.includes(item));
};

export {uniqBy};

/**
 * Returns arrays with teh same length, this is used in the generation of PR's from excel
 * @param {[]} glNumber
 * @param {[]} allocatedFor
 * @param {[]} wbs
 * @param {[]} costCenter
 * @param {[]} profitCenter
 * @return {[]}
 */
export const normalizeArrays = (glNumber, allocatedFor, wbs, costCenter, profitCenter) => {
    // Split the strings by ';'
    let glNumberArr = glNumber?.value?.split(';') || [];
    let allocatedForArr = allocatedFor?.split(';') || [];
    let wbsArr = wbs?.value?.split(';') || [];
    let costCenterArr = costCenter?.value?.split(';') || [];
    let profitCenterArr = profitCenter?.value?.split(';') || [];
    // Get the maximum length of the arrays
    const maxLength = Math.max(glNumberArr.length, allocatedForArr.length, wbsArr.length, costCenterArr.length, profitCenterArr.length);

    // Function to pad the arrays to the max length
    const padArray = (arr, length, isLabelValue) => {
        while (arr.length < length) {
            arr.push(''); // Fill with empty strings
        }
        if (isLabelValue) {
            return arr.map((element) => {
                return checkLabelValueObject(element);
            });
        } else {
            return arr;
        }
    };

    // Pad all arrays to the maximum length
    glNumberArr = padArray(glNumberArr, maxLength, true);
    allocatedForArr = padArray(allocatedForArr, maxLength, false);
    wbsArr = padArray(wbsArr, maxLength, true);
    costCenterArr = padArray(costCenterArr, maxLength, true);
    profitCenterArr = padArray(profitCenterArr, maxLength, true);
    return [glNumberArr, allocatedForArr, wbsArr, costCenterArr, profitCenterArr];
};

/**
 * Returns a new array with old and new values merged with unique key
 * @param {[]} oldValues
 * @param {[]} newValues
 * @param {String} key
 * @return {[]}
 */
export const mergeUniqueValuesWithKey = (oldValues, newValues, key) =>{
    const oldArr = oldValues || [];
    const newArr = newValues || [];

    const combinedData = [...oldArr, ...newArr];

    const mergedData = combinedData.reduce((acc, current) => {
        const x = acc.find((item) => item[key] === current[key]);
        if (!x) {
            acc.push(current);
        }
        return acc;
    }, []);

    return mergedData;
};
